module.exports = __webpack_public_path__ + "img/xuzhou.b49d8ee.png";